import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Console } from 'console';
import { getIdToken } from '../../auth';
import Repository from '../../components/Repository/Repository';
import {  IAdminAccessRepository} from '../../types/Repositorys';
import chalk from 'chalk';
import logSymbols from 'log-symbols';
import { refreshToken } from '../../refreshToken';
import { getHttpErrorCategory } from "../../../src/Helpers/Http.commons"
import { HttpStatus, isHttpCodeSuccess, findHttpStatusInfo } from "../../../src/Helpers/Http.commons";
const moment = require('moment');
import { BASE_URL_ENDPOINT } from '../../config/env';

interface IState{
    result: IAdminAccessRepository | any,
    error: null | any
    statusCode: number | null | undefined;
    response: Object | undefined;
}

const initialState: IState = {
    result:'',
    error: null,
    statusCode: null,
    response: undefined,
}

export const repositoryAccessById = createAsyncThunk(
  'repositoryAccess/fetchById',
  async (requestId: string): Promise<any> => {
    try {
      const token = getIdToken();
      const response = await fetch(
        `${BASE_URL_ENDPOINT}/management-ctx/api/v2/repository-access/${requestId}`,
        {
          method:'GET',
          headers: {
            'Content-type':'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization':`Bearer ${token}`,
          },
        },
      );

      console.log("respuesta",response);
      if (response.status === 403) {
        throw new Error('Forbidden: Access is denied.');
      } else if (response.status === 401){
        throw new Error('Forbidden: Enough Permisions.');
      }
      else if (!response.ok) {
        throw new Error(`Error fetching repository access by ID: ${response.statusText}`);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      throw error;
    }
  },
);


export const patchAccessRepositoryById = createAsyncThunk(
  "patchAccessRepositoryById",
  async ({
    id,
    data,
    repositoryName,
  }: {
    id: string;
    data: object;
    repositoryName: string;
  }) => {
    try {
      const token = getIdToken();
      const responseData = await fetch(
        `${BASE_URL_ENDPOINT}/management-ctx/api/v2/repository-access/${id}`,
        {
          method: "PATCH",
          headers: {
            "Content-type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "repository-name": `${repositoryName}`,
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(data),
        }
      );
      console.log('patchAccessRepositoryById responseData', responseData);

      if (isHttpCodeSuccess(responseData.status)) {
        return {
          statusCode: responseData.status,
          response: responseData,
          error: null,
        };
      } else {
        const httpData:any = findHttpStatusInfo(responseData.status);
        const { message, title } = httpData;

        return {
          statusCode: responseData.status,
          response: title,
          error: message
        };
      }
    } catch (error) {
      console.error(error);
      throw new Error("Error al procesar la solicitud");
    }
  }
);

const RepositorysSlice = createSlice({
    name: "repositorysSlice",
    initialState,
    reducers:{},
    extraReducers(builder) {
      builder
      .addCase(repositoryAccessById.pending, (state) => {
        state.result='';
        // console.log("result",state.result)
        state.error= null;
        // console.log("Error",state.error)
      })
      .addCase(repositoryAccessById.fulfilled, (state, action) => {
        state.result= action.payload;
        // console.log("result",state.result)
        state.error= null;
        // console.log("Error",state.error)
      })
      .addCase(repositoryAccessById.rejected, (state, action) => {
        state.result='';
        console.log("result",state.result)
        state.error = action.error.message;
        console.log("Error",state.error)
      });
      builder
      .addCase(patchAccessRepositoryById.pending, (state) => {
        state.statusCode = null
        state.response = {}
        state.error = null
      })
      .addCase(patchAccessRepositoryById.fulfilled, (state, action) => {
        console.log('patchAccessRepositoryById fulfilled', action);

        const { statusCode, response, error} = action.payload

        state.statusCode = statusCode
        state.response = response
        state.error = error
      })
      .addCase(patchAccessRepositoryById.rejected, (state, action) => {
        console.log('patchAccessRepositoryById rejected', action);

        state.statusCode = 500
        state.response = 'Error en el servidor, testing',
        state.error = "Hubo un error al procesar su solicitud. Por favor, inténtelo de nuevo más tarde."
      });
    },
});

export default RepositorysSlice.reducer;